import { Dispatch } from 'redux';
import { FormikActions } from 'formik';
import { push, replace } from 'connected-react-router';
import { AxiosResponse, AxiosRequestConfig, AxiosError } from 'axios';

import { IUser } from 'src/@types';
import axios from '../../common/axios-instance/axios-instance';
import { IUserFormValues } from 'src/features/user-entry/user-entry';

import * as constants from './constants';
import { handleError } from '../utils';

export interface IUpdateUser {
  type: constants.UPDATE_USER;
  payload: IUser;
}

export interface IClearUser {
  type: constants.CLEAR_USER;
}

export type UserAction = IUpdateUser | IClearUser;

export const updateUser = (user: IUser): IUpdateUser => {
  return {
    type: constants.UPDATE_USER,
    payload: user
  };
};

export const clearUser = (): IClearUser => {
  return {
    type: constants.CLEAR_USER
  };
};

export const getUser = (id: number) => {
  return (dispatch: Dispatch<IUpdateUser>) => {
    return axios
      .get<IUser>('/api/user?id=' + id)
      .then((res: AxiosResponse<IUser>) => {
        return dispatch(updateUser(res.data));
      });
  };
};

export const submitUser = (
  user: IUser,
  onSuccessfulSubmit: (user: IUser) => void,
  { setSubmitting }: FormikActions<IUserFormValues>
) => {
  return (dispatch: Dispatch) => {
    const axiosRequest: AxiosRequestConfig = {
      method: !user.id ? 'post' : 'put',
      url: !user.id ? '/api/user/register' : '/api/user',
      data: user
    };

    return axios(axiosRequest)
      .then((res: AxiosResponse<IUser>) => {
        onSuccessfulSubmit(res.data);
        setSubmitting(false);
        if (!user.id) {
          dispatch(replace('/customers/view/' + res.data.id));
        }
      })
      .catch((error: AxiosError) => {
        console.log(error);
        setSubmitting(false);
      });
  };
};

export const deleteUser = (id: number) => {
  return (dispatch: Dispatch) => {
    return axios
      .post<IUser>('/api/user/delete', { id })
      .then(() => {
        return dispatch(clearUser());
      })
      .then(() => {
        return dispatch(push('/users'));
      })
      .catch(handleError);
  };
};



// WEBPACK FOOTER //
// ./src/modules/user/action.ts